

















import {
  computed,
  defineComponent,
  PropType,
  ref
} from '~/utils/nuxt3-migration'
import { ciCall } from '~/icons/source/solid/call'
import PhoneListPopup from '~/components/car/classifieds/view/partials/call-button/PhoneListPopup.vue'
import { useNamespacedStore } from '~/compositions/store'
import {
  CLASSIFIED_VIEW_NS,
  ClassifiedViewState
} from '~/store/modules/shared/classifieds/view/state'
import { useI18n } from '~/compositions/i18n'
import { defineComponentTranslations } from '~/utils/i18n'
import { sellerIsOfTypeDealer } from '~/utils/user'
import { ButtonSize } from '~/models/app/button'
import { USER_NS, UserState } from '~/store/modules/shared/user/state'

export default defineComponent({
  components: { PhoneListPopup },
  props: {
    size: {
      type: String as PropType<ButtonSize>,
      default: 'sm'
    },
    inSellerInfo: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup(props) {
    const { state, getters } = useNamespacedStore<ClassifiedViewState>(
      CLASSIFIED_VIEW_NS
    )
    const { getters: userGetters } = useNamespacedStore<UserState>(USER_NS)

    const isAdmin = computed(() => userGetters('isAdmin'))

    const seller = computed(() => state.seller)
    const { t } = useI18n()

    const sellerIsBlacklistedSuspiciousOrFraudster = computed(() =>
      getters('sellerIsBlacklistedSuspiciousOrFraudster')
    )

    const sellerOnlyContactViaMessages = computed(() =>
      getters('sellerOnlyContactViaMessages')
    )

    const showCallButton = computed(() => {
      if (
        (sellerIsBlacklistedSuspiciousOrFraudster.value ||
          sellerOnlyContactViaMessages.value) &&
        !isAdmin.value
      ) {
        return false
      }

      const hasPublicTelephones = seller.value?.has_public_telephone

      return hasPublicTelephones || sellerIsOfTypeDealer(seller.value)
    })

    const showTelephonesModal = ref(false)

    const labelToShow = computed(() => {
      if (props.inSellerInfo) {
        return t('show_telephone')
      }

      return t('telephone')
    })

    return {
      ciCall,
      showTelephonesModal,
      showCallButton,
      seller,
      labelToShow,
      sellerIsBlacklistedSuspiciousOrFraudster
    }
  },
  i18n: defineComponentTranslations({
    show_telephone: {
      en: 'Show telephone',
      el: 'Εμφάνιση τηλεφώνου'
    },
    show_email: {
      en: 'Show email',
      el: 'Εμφάνιση email'
    }
  })
})
